export default "__VITE_ASSET__DJ9S1iTh__"